import { Component, OnInit, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../Services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModalService } from '../../Services/modal.service';
import { Subject } from 'rxjs';
import { GalleryItem } from '@ngx-gallery/core';
import { NgxGalleryOptions } from '@autotaxatiepartners/ngx-gallery';
import { SearchDirectiveComponent } from '../../Directives';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NewBid } from '../../Models/bid.model';

@Component({
    selector: 'app-biedingen-detail',
    templateUrl: 'biedingen-detail.component.html',
    styleUrls: ['biedingen-detail.component.scss'],
    standalone: false
})

export class BiedingenDetailComponent implements OnInit {
    public galleryOptions: NgxGalleryOptions[];
    public galleryImages = [];

    public state: boolean;
    public images: GalleryItem[] = [];
    public _damageAlbum: any[] = [];
    public allItems: any;
    public closeResult: string;
    public bidsDisabled: boolean;
    public showBidError = false;
    public showNoBidMessage = false;
    public newBid: NewBid = {};
    public taxID: string;

    public carouselSubject = new Subject<any>();
    public onlyComments = true;
    public loading: boolean;
    public gaspedaalLoading: boolean;

    public formData: any = {};
    public showSearch: any;
    public BodyTypes: any;
    public TransmissionTypes: any;
    public FuelTypes: any;

    public pagesArray: any;
    public totalPages: number;
    public SearchResults: any;
    public TotalResults: any;
    public currentPage: number;

    public showModal = false;
    public nextTaxDisabled: boolean;

    public SearchSettings = {
        limit: 50,
        currentPage: 1,
        ordering: '[{"field":"id","direction":"ASC"}]',
        filter: '',
        fields: ['id', 'VehicleSpecification-Vehicle-make', 'BidList', 'VehicleSpecification-Vehicle-registration',
            'VehicleSpecification-Vehicle-year', 'VehicleSpecification-BodyType', 'VehicleSpecification-FuelType',
            'VehicleSpecification-mileage', 'dateDelivery', 'StatusType-descriptionNl', 'assignedDate',
            'OriginCommercialType-name', 'OriginChannelType-name', 'selfRequested']
    };

    constructor(
        private modal: ModalService,
        private router: Router,
        private ngZone: NgZone,
        private apiService: ApiService,
        private modalService: NgbModal,
        private _location: Location,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private title: Title,
        private sanitizer: DomSanitizer) {
    }

    private getTaxDetails() {
        // Fix for navigating to next tax.
        if (this.taxID === undefined) {
            this.taxID = this.route.snapshot.paramMap.get('id');
            this.title.setTitle(`Expertteam Taxatie T${this.taxID}`);
            this.getData(this.taxID, true);
            this.bidsDisabled = false;
        } else {
            this.title.setTitle(`Expertteam Taxatie T${this.taxID}`);
            this.getData(this.taxID, true);
        }
    }

    public ngOnInit() {
        this.galleryOptions = [
            {
                thumbnailsColumns: 4,
                previewAnimation: false,
                previewDownload: true,
                previewArrows: true,
                previewCloseOnEsc: true,
                previewFullscreen: true,
                previewRotate: true,
                previewBullets: true,
                previewKeyboardNavigation: true,
                previewCloseOnClick: true,
                previewZoom: true,
                previewZoomStep: 0.4,
                previewZoomMax: 5,
                previewDescription: true,
                imageDescription: true,
                imageAnimation: 'none',
            }
        ];

        this.nextTaxDisabled = false;
        this.loading = true;
        // Start checking for screen sizes on init
        this.checkForResize();
        this.getTaxDetails();
    }

    private getData(id: string, loading: boolean) {
        if (loading) this.loading = true;

        this.images = [];
        this.newBid.comment = '';
        this.images.splice(0, this.images.length);
        return this.apiService.getValuationID(id).subscribe(data => {
            this.allItems = data.data;
            // Save images in array to show
            if (this.allItems.VehicleSpecification.Images) {
                for (const image of this.allItems.VehicleSpecification.Images) {
                    const src = image.imageUrl;
                    const thumb = image.thumbnailUrl;
                    this.galleryImages.push({
                        small: thumb,
                        medium: src,
                        big: src
                    });
                }
            }
            // Save images in array to show
            let index = 0;
            if (this.allItems.VehicleSpecification.DamageSpecification &&
                this.allItems.VehicleSpecification.DamageSpecification.Damages) {
                for (const damage of this.allItems.VehicleSpecification.DamageSpecification.Damages) {
                    if (damage.image !== null) {
                        index++;
                        const damageDescriptions = `Schade: ${index} - onderdeel: ${damage.PartType.descriptionNl}`;
                        this.galleryImages.push({
                            small: damage.thumbnail,
                            medium: damage.image,
                            big: damage.image,
                            label: 'Schadefoto',
                            description: damageDescriptions
                        });
                    }
                }
            }

            if (this.allItems.BidList.MyBid) {
                if (this.allItems.BidList.MyBid.comment !== null) {
                    this.newBid.comment = this.allItems.BidList.MyBid.comment;
                }
            }

            if (this.allItems.BidList.BidTerm.open === true) {
                this.onlyComments = false;
            } else {
                if (this.allItems.BidList.MyBid != null) {
                    this.onlyComments = true;
                } else {
                    this.bidsDisabled = true;
                }
            }
            this.loading = false;
        },
            err => {
                this.modal.showGetError('taxatie');
            });
    }

    private checkForResize() {
        window.onresize = () => {
            this.ngZone.run(() => {
                if (window.innerWidth < 700) {
                    this.state = true;
                } else {
                    this.state = false;
                }
            });
        };
    }

    public openModal(content: any) {
        this.modalService.open(content).result.then(() => {
            this._location.back();
        }).catch(() => {
            this._location.back();
        });
    }

    public print(): void {
        let printContents, popupWin;
        const printElement = document.getElementById('print');
        if (!printElement) return;

        printContents = printElement.innerHTML;
        popupWin = window.open('', '_blank', '');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
            <head>
              <title>Printweergave taxatie</title>
              <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css' rel='stylesheet'
              integrity='sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO' crossorigin='anonymous'>
            </head>
            <body onload='window.print()'>
            <style>
            .pagebreak { page-break-before: always; } /* page-break-after works, as well */
            </style>
            ${printContents}</body>
          </html>`
        );
        popupWin.document.close();
    }

    public email() {
        let printContents, popupWin;
        const printElement = document.getElementById('print');
        if (!printElement) return;

        printContents = printElement.innerHTML;
        popupWin = window.open('', '_blank', '');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
            <head>
              <title>Email voorbeeld</title>
              <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css' rel='stylesheet'
              integrity='sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO' crossorigin='anonymous'>
            </head>
            <body onload='window.print()'>
            <style>
            .pagebreak { page-break-before: always; } /* page-break-after works, as well */
            </style>
            ${printContents}</body>
          </html>`
        );
        popupWin.document.close();
    }

    public search() {
        return this.apiService.getValuations(this.SearchSettings.limit, 1, this.SearchSettings.ordering,
            this.SearchSettings.filter, this.SearchSettings.fields, '')
            .subscribe(searchResult => {
                this.SearchResults = searchResult.data;
                this.TotalResults = searchResult.paginator.records;
                this.totalPages = searchResult.paginator.pages;
                // Put pages inside array for view
                const items: number[] = [];
                for (let i = 1; i <= searchResult.paginator.pages; i++) {
                    items.push(i);
                }
                this.pagesArray = items;
                this.showSearch = true;
            });
    }

    public addBid(nextBid: boolean) {
        if (this.newBid.bid != null) {
            this.loading = true;
            return this.apiService.addBid(this.newBid.bid, this.newBid.comment ?? '', false, Number(this.taxID))
                .subscribe(data => {
                    this.loading = false;
                    if (data.error === false) {
                        this.showBidError = false;
                        this.showNoBidMessage = false;
                        if (nextBid === true) {
                            this.newBid.bid = null;
                            this.newBid.comment = '';
                            this.navNext();
                        } else {
                            // Reload taxation data.
                            this.showBidError = false;
                            this.showNoBidMessage = false;
                            this.newBid = {};
                            this.getTaxDetails();
                        }
                    } else {
                        this.showBidError = true;
                    }
                });
        } else {
            this.showNoBidMessage = true;
        }
        return null;
    }

    public addComment(bidListId: string) {
        this.loading = true;
        return this.apiService.addBidComment(this.newBid.comment, bidListId)
            .subscribe(data => {
                this.getTaxDetails();
                this.images = [];
                this._damageAlbum = [];
                this.loading = false;
            }, err => {
                this.loading = false;
                this.modal.showGetError('opmerking');
            });
    }

    public compare() {
        this.gaspedaalLoading = true;
        this.toastr.info('Gaspedaal wordt geopend in een nieuw tabblad.', 'Even geduld a.u.b.');
        this.apiService.getGaspedaalLinkValuation(Number(this.taxID)).subscribe(data => {
            this.gaspedaalLoading = false;
            if (data.error === false) {
                window.open(data.data.link, '_blank');
            } else {
                this.toastr.error('Er is een fout opgetreden bij het openen van Gaspedaal.', 'Fout');
            }
        }, err => {
            this.gaspedaalLoading = false;
            this.toastr.error('Er is een fout opgetreden bij het openen van Gaspedaal.', 'Fout');
        });
    }

    public navPrevPage() {
        const idListData = localStorage.getItem('idList');
        if (!idListData) return;

        const navData = JSON.parse(idListData);
        const page = navData.lastPage;
        this.ngZone.run(() => this.router.navigateByUrl(page));
    }

    public navNext() {
        this.galleryImages = [];
        this._damageAlbum = [];
        this.newBid.comment = '';

        const idListData = localStorage.getItem('idList');
        if (!idListData) return;

        const navData = JSON.parse(idListData);

        let currentIndex = Number(navData.lastIndex);
        const nextIndex = (currentIndex += 1);

        navData.lastIndex = JSON.stringify(nextIndex);
        localStorage.setItem('idList', JSON.stringify(navData));

        this.taxID = navData.navigationData[nextIndex].id;
        this.nextTaxDisabled = false;
        // This will unset the search modal.
        this.showSearch = false;
        this.allItems = null;
        this.ngZone.run(() => this.router.navigateByUrl(`${navData.routerLink}/${navData.navigationData[nextIndex].id}`));
        this.getData(navData.navigationData[nextIndex].id, true);

        // Disable the next button.
        if (navData.navigationData.length > nextIndex) {
            this.nextTaxDisabled = false;
        } else {
            this.nextTaxDisabled = true;
        }
    }

    public scrollToBidElement(id: any) {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }

    public searchVehicles() {
        // Open the VehicleSearchModalComponent as a modal
        const modalRef = this.modalService.open(SearchDirectiveComponent, {
            size: 'xl',
            backdrop: 'static',
        });

        // Pass data to the modal component
        modalRef.componentInstance.settings = this.allItems;
    }

    public checkForDecimals() {
        const old = String(this.newBid.bid ?? '');
        this.newBid.bid = old ? Number(old.replace(/\,/g, '').replace(/\./g, '')) : null;
    }

    // ==================== Helper Methods for Template ====================

    // Energy label helpers
    getEnergyLabelColor(label: string): string {
        const colors = {
            a: 'darkgreen',
            b: 'green',
            c: 'rgb(161, 216, 161)',
            d: 'rgb(179, 179, 0)',
            e: 'rgb(255, 157, 87)',
            f: 'rgb(194, 87, 0)',
            g: 'red'
        };
        return colors[label?.toLowerCase()] || '#6c757d';
    }

    get hasEnergyLabel(): boolean {
        return !!this.allItems?.VehicleSpecification?.Vehicle?.energyLabel;
    }

    // Computed properties for common nested values
    get vehicle() {
        return this.allItems?.VehicleSpecification?.Vehicle;
    }

    get fuelType() {
        return this.allItems?.VehicleSpecification?.FuelType;
    }

    get damages() {
        return this.allItems?.VehicleSpecification?.DamageSpecification?.Damages;
    }

    get isImported(): boolean {
        return this.vehicle?.officialImport === 'no';
    }

    get originCountry(): string | null {
        return this.allItems?.VehicleSpecification?.CountryOfOriginType?.descriptionNl || null;
    }

    // Sanitization methods for innerHTML
    get sanitizedCustomerComment(): SafeHtml | null {
        if (!this.allItems?.VehicleSpecification?.commentVehicleInfoCustomer) return null;
        return this.sanitizer.bypassSecurityTrustHtml(
            this.allItems.VehicleSpecification.commentVehicleInfoCustomer
        );
    }

    get sanitizedExtraInfo(): SafeHtml | null {
        if (!this.allItems?.VehicleSpecification?.extraInfo) return null;
        return this.sanitizer.bypassSecurityTrustHtml(
            this.allItems.VehicleSpecification.extraInfo
        );
    }

    get sanitizedAccessoriesComment(): SafeHtml | null {
        if (!this.allItems?.VehicleSpecification?.commentAccessories) return null;
        return this.sanitizer.bypassSecurityTrustHtml(
            this.allItems.VehicleSpecification.commentAccessories
        );
    }

    get sanitizedDamageDescription(): SafeHtml | null {
        if (!this.allItems?.VehicleSpecification?.DamageSpecification?.description) return null;
        return this.sanitizer.bypassSecurityTrustHtml(
            this.allItems.VehicleSpecification.DamageSpecification.description
        );
    }

    get sanitizedTechnicalDefectsComment(): SafeHtml | null {
        if (!this.allItems?.VehicleSpecification?.commentTechnicalDefects) return null;
        return this.sanitizer.bypassSecurityTrustHtml(
            this.allItems.VehicleSpecification.commentTechnicalDefects
        );
    }
}
